<template>
  <page class="bg-color">
    <div class="order-detail-page">
      <div class="stickyTop">
        <div class="top-tab">
          <van-tabs v-model="active" @change="orderTab(active)" sticky>
            <van-tab :key="item.id" v-for="item in tabs" :name="item.index" :title="item.title">
              <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="finishedText"
                @load="getOrderList(active)"
              >
                <ul class="order-list" v-if="listData.length !== 0">
                  <li class="list-item" v-for="(item, index) in listData" :key="index">
                    <router-view></router-view>
                    <div class="order-num">
                      <span class="fl normal text-over">
                        订单号:{{ item.orderCode }}
                        <ClickCopy :content="`订单号：${item.orderCode}`">复制</ClickCopy>
                      </span>
                      <template v-if="item.convertOrderStatus === 0">
                        <span class="fr red-color">未付款</span>
                      </template>
                      <template v-if="item.convertOrderStatus === 2">
                        <span class="fr green-color">待发货</span>
                      </template>
                      <template v-if="item.convertOrderStatus === 3">
                        <span class="fr green-color">待收货</span>
                      </template>
                      <!--已收获-->
                      <template v-if="item.convertOrderStatus === 4">
                        <span class="fr green-color">已收货</span>
                      </template>
                      <!--售后中-->
                      <template v-if="item.convertOrderStatus === 5">
                        <span class="fr green-color">售后中</span>
                      </template>
                      <template v-if="item.convertOrderStatus === 6">
                        <span class="fr green-color">已售后</span>
                      </template>
                      <!-- <span  :class="['fr red-color', orderStatus(item.convertOrderStatus)? 'red-color': 'green-color']">{{orderStatus(item.convertOrderStatus)}}</span> -->
                    </div>
                    <div
                      class="pic-box"
                      @click="toOrderDetail(item)"
                      v-for="(list, pIndex) in item.orderGoodss"
                      :key="pIndex"
                    >
                      <img :src="list.skuDto ? list.skuDto.skuThumb : ''" />
                      <div class="card-msg">
                        <p class="card-name">{{ list.skuDto ? list.skuDto.skuName : '' }}</p>
                        <p class="card-num">￥{{ list.goodsPrice }} X {{ list.goodsNum }}</p>
                        <p class="card-date">
                          <formatData class="time" :date="item.addTime * 1000" />
                          <span class="pic-price">¥{{ list.totalMoney.toFixed(2) }}</span>
                        </p>
                      </div>
                    </div>
                    <div style="display: flex; justify-content: flex-end">
                      <div
                        class="download"
                        v-show="
                          item.convertOrderStatus === 6 ||
                          item.convertOrderStatus === 5 ||
                          item.convertOrderStatus === 4 ||
                          item.convertOrderStatus === 3
                        "
                      >
                        <!-- 查看物流 -->
                        <template v-if="item.orderClassify !== 9">
                          <van-button type="danger" @click="checkShipping(item)" class="plain">
                            查看物流
                          </van-button>
                        </template>
                      </div>
                      <div
                        class="download"
                        v-show="
                          item.convertOrderStatus === 0 ||
                          item.convertOrderStatus === 4 ||
                          item.convertOrderStatus === 3
                        "
                      >
                        <!-- 待发货 -->
                        <!-- <template v-if="item.convertOrderStatus === 2 ">
                      <van-button type="danger" class="download-btn">待发货</van-button>
                    </template> -->
                        <!-- 待付款 -->
                        <template v-if="item.convertOrderStatus === 0">
                          <van-button type="danger" @click="toPaying(item)" class="download-btn">
                            立即支付
                          </van-button>
                        </template>

                        <!--已收货-->
                        <template v-if="item.convertOrderStatus === 4">
                          <van-button
                            type="danger"
                            @click="handleOnceMore(item)"
                            class="download-btn"
                            v-if="item.orderClassify !== 2"
                          >
                            再次购买
                          </van-button>
                          <!-- <van-button
                            type="danger"
                            @click="handleDownload(item)"
                            class="download-btn"
                            v-else
                          >
                            下载卡密
                          </van-button> -->
                        </template>
                        <!-- 确认收货 -->
                        <template v-if="item.convertOrderStatus === 3">
                          <van-button
                            type="danger"
                            @click="handleConfirm(item)"
                            class="download-btn"
                            v-if="item.orderClassify === 1"
                          >
                            确认收货
                          </van-button>
                          <van-button
                            type="danger"
                            @click="handleDownload(item)"
                            class="download-btn"
                            v-else-if="item.orderClassify === 2"
                          >
                            下载卡密
                          </van-button>
                          <!-- <van-button
                          type="danger"
                          @click="handleConfirm(item)"
                          class="download-btn"
                          v-else
                        >
                          立即激活
                        </van-button> -->
                        </template>
                        <!--查看卡密-->
                        <template>
                          <van-button
                            type="danger"
                            @click="showActiveSn(item)"
                            class="download-btn"
                            v-if="
                              item.orderClassify === 9 &&
                              item.orderGoodss[0].orderMovieActiveList &&
                              item.orderGoodss[0].orderMovieActiveList.length
                            "
                          >
                            查看卡密
                          </van-button>
                        </template>
                      </div>
                    </div>
                  </li>
                </ul>
                <ul class="order-list" v-else>
                  <div class="nothing">
                    <span>无订单记录</span>
                    <br />
                    <span>可前往商城首页查看更多商品</span>
                    <van-button @click="toHomePage" class="to-home-btn" type="danger">
                      去首页逛逛
                    </van-button>
                  </div>
                  <!-- <div class="to-home">

                  </div> -->
                </ul>
              </van-list>
            </van-tab>
          </van-tabs>
        </div>
      </div>
      <div class="order-main">
        <van-popup v-model="showCode" position="bottom" :style="{ height: '60%' }">
          <div class="code-box" @click.stop>
            <img src="@/assets/code.png" alt="" />
            <van-button type="warning" class="saveBtn color-white">一键保存</van-button>
            <span class="tips">扫码激活权益 • 保存二维码稍后激活 • 将图片赠给好友激活</span>
          </div>
        </van-popup>
        <van-overlay :show="showGetWay" @click="showGetWay = false" class="dialog-box">
          <div class="wrapper get-way-wrapper" @click.stop>
            <h3 class="get-way-title">请选择获取方式</h3>
            <p style="text-align: center; color: #e64340ff; font-size: 12px; margin-top: 29px">
              此文件为加密文件，文件密码为订单后6位
            </p>
            <van-button type="default" @click="handleSendEmail" class="get-way-btn btn2">
              发送至我的邮箱
            </van-button>
            <!-- <van-button type="danger" @click="cardCreateUserToken" class="get-way-btn btn1">
              本地下载
            </van-button> -->
          </div>
        </van-overlay>
        <!-- <van-dialog v-model="showGetWay" confirmButtonText="本地下载" class="dialog-box"
        cancelButtonText="发送至我的邮箱" @confirm="downloadNative()" @cancel="handleSendEmail" show-cancel-button>
            <h3 class="dialogTitle">请选择获取方式</h3>
            <p style="text-align:center;color:#E64340FF;font-size:12px">此文件为加密文件，文件密码为订单后6位</p>
       </van-dialog> -->
        <van-overlay :show="showSend">
          <div class="wrapper wrapper-box" @click.stop>
            <h3 class="email-title">请输入您的邮箱地址</h3>
            <van-field
              type="email"
              class="email-input"
              border
              v-model="email"
              placeholder="邮箱地址"
            />
            <p style="text-align: center; color: #e64340ff; font-size: 12px">
              此文件为加密文件，文件密码为订单后6位
            </p>
            <van-button type="default" @click="handleCancelSend" class="dialog-btn btn2">
              取消
            </van-button>
            <van-button type="danger" @click="handleConfirmSendEmail" class="dialog-btn btn1">
              确认
            </van-button>
          </div>
        </van-overlay>
      </div>
    </div>
  </page>
</template>
<script>
import { Dialog } from 'vant';
import ClickCopy from '@/components/ClickCopy';
import formatData from '@/components/formatData';
import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    formatData,
    ClickCopy
  },
  data() {
    return {
      email: '',
      showGetWay: false,
      showSendEmail: false,
      showSend: false,
      loading: false,
      finished: false,
      showCode: false,
      active: this.$route.query.id,
      paymanetsItem: [],
      returnsItem: [],
      receiptsItem: [],
      completesItem: [],
      pageNum: 1,
      pageSize: 10,
      typeStatus: 0,
      listData: [],
      finishedText: '',
      orderSn: '',
      tabs: [
        {
          title: '全部',
          id: 0
        },
        {
          title: '待付款',
          id: 1
        },
        {
          title: '待发货',
          id: 2
        },
        {
          title: '待收货',
          id: 3
        },
        {
          title: '已收货',
          id: 4
        }
      ]
    };
  },
  methods: {
    checkShipping(data) {
      let shippingNoList = [];
      data.orderGoodss.forEach((item) => {
        if (!shippingNoList.includes(item.shippingNo) && item) {
          shippingNoList.push(item.shippingNo);
        }
      });
      let goods = [];
      data.orderGoodss.forEach((ele) => {
        if (ele.goodsId === ele.skuDto.id) {
          goods.push({
            shippingNo: ele.shippingNo,
            skuName: ele.skuDto.skuName
          });
        }
      });
      goods = JSON.stringify(goods);
      shippingNoList.join(',');
      if (shippingNoList != '') {
        this.$router.push({
          name: 'track-logistics',
          query: { nu: shippingNoList, goods: goods, orderCode: data.orderCode }
        });
      } else {
        this.$toast('暂无物流单号！');
      }
    },
    // ...mapActions(['setEventTracking']),
    orderTab(active) {
      this.$router.push({
        name: 'my-order',
        query: {
          id: active
        }
      });
      this.pageNum = 1;
      this.listData = [];
      this.finished = false;
      this.loading = true;
      this.getOrderList(active);
    },
    getOrderList(type) {
      let params = {};
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      if (type || type === 0) {
        params.orderStatus = type;
      } else {
        params.orderStatus = this.typeStatus;
      }
      this.$service.getOrderList(params).then((res) => {
        if (res.code === 200) {
          this.listData = res.data.list;
          if (this.pageNum === 1) {
            this.listData = [];
          }
          this.listData = this.listData.concat(res.data.list);
          if (this.pageNum >= res.data.totalPage) this.finished = true;
        } else {
          this.finished = true;
        }
        this.pageNum++;
        this.loading = false;
        if (this.listData.length > 0) {
          this.finishedText = '没有更多了';
        } else {
          this.finishedText = '';
        }
      });
    },
    toOrderDetail(item) {
      // let goodsId = item.orderGoodsList[0].goodsId
      // this.$router.push({ name: 'order-detail', query: { orderSn: item.orderSn, type: this.active } })
      this.$router.push({
        name: 'order-detail',
        query: { orderSn: item.orderCode, type: item.actType, sourceFlag: item.sourceFlag }
      });
    },
    // 再次购买
    handleOnceMore(item) {
      console.log('item', item);
      this.$service
        .inputCartNew({
          goodsAndNumDTO: item.orderGoodss.map((data) => {
            return {
              goodsId: data.goodsId,
              num: 1
            };
          })
        })
        .then((res) => {
          this.$router.push({ name: 'store-shopping-car' });
        });
    },
    toPaying(item) {
      console.log('toPaying item', item);
      // this.setEventTracking({
      //   vm: this,
      //   orderNo: item.orderCode
      // })
      this.$service
        .webPay({
          merger: false,
          orderAmount: item.orderAmount,
          orderSn: item.orderCode,
          payWay: this.$getBrowser(),
          sourceFlag: item.sourceFlag,
          returnUrl: window.location.origin + '/pay-success?orderSn=' + item.orderCode
        })
        .then((res) => {
          window.location = res.data;
        });
    },
    orderStatus(type) {
      switch (type) {
        case 0:
          return '待付款';
        case 1:
          return '已付款';
        case 2:
          return '待发货';
        case 3:
          return '待收货';
        case 4:
          return '已收货';
        case 5:
          return '售后中';
        case 6:
          return '已完成售后';
        case 7:
          return '售后申请驳回';
        default:
          return ' ';
      }
    },
    toHomePage() {
      this.$router.push({ name: 'store-home' });
    },
    handleConfirm(obj) {
      if (obj.orderClassify === 1) {
        this.$dialog
          .confirm({
            message: '请确认是否已经到货？'
          })
          .then(() => {
            this.$service
              .confirmReceived({
                orderCode: obj.orderCode,
                sourceFlag: obj.sourceFlag,
                tenantId: obj.platformCode
              })
              .then((res) => {
                if (res.message === 'SUCCESS') {
                  this.$toast('确认收货成功！');
                  location.reload();
                }
              });
          })
          .catch(() => {});
      } else if (obj.orderClassify === 3 || obj.orderClassify === 4) {
        // 激活相关
        // this.$service
        //   .immeActiveGetActiveSn({
        //     orderSn: obj.orderCode
        //   })
        //   .then((res) => {
        //     const data = res.data
        //     this.$router.push({
        //       name: 'member-activation',
        //       query: {
        //         activeSn: data[0].activeSn,
        //         isActive: 1
        //       }
        //     })
        //   })
      } else {
        // 卡密相关
        this.showGetWay = true;
      }
    },
    handleDownload(item) {
      this.showGetWay = true;
      this.orderSn = item.orderCode;
    },
    handleSendEmail() {
      this.showGetWay = false;
      this.showSend = true;
    },
    // cardCreateUserToken() {
    //   this.$service
    //     .cardCreateUserToken({
    //       orderSn: this.orderCode
    //     })
    //     .then((res) => {
    //       if (res.data) {
    //         let userToken = res.data
    //         this.downloadNative(userToken)
    //       }
    //     })
    // },
    // downloadNative(userToken) {
    //   const url =
    //     '/mini-program-server/api/order/v1/downloadVirtualCardExcel?userToken=' + userToken
    //   let api = process.env.VUE_APP_TITLE === 'production' ? url : '/api' + url
    //   window.location.href = api
    // },
    handleCancelSend() {
      this.showSend = false;
      this.showGetWay = true;
    },
    handleConfirmSendEmail() {
      var reg = new RegExp(
        '^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$'
      );
      if (this.email === '') {
        return this.$toast('请输入邮箱');
      }
      if (!reg.test(this.email)) {
        return this.$toast('请输入正确的邮箱');
      }
      this.showSend = true;
      // this.$service
      //   .sendEmailVirtualCardExcel({ email: this.email, orderSn: this.orderSn })
      //   .then((res) => {
      //     if (res.code === 200) {
      //       this.$toast('已发送至您的邮箱，请注意查收！')
      //       this.showSend = false
      //     }
      //   })
    },
    showActiveSn(data) {
      Dialog.alert({
        title: '查看卡密',
        message: `卡号：${data.orderGoodss[0].orderMovieActiveList[0].activeSn}\n 卡密：${data.orderGoodss[0].orderMovieActiveList[0].activeKey}`,
        theme: 'round-button'
      }).then(() => {
        // on close
      });
    },
    init() {
      const id = parseInt(this.$route.query.id);
      if (id) {
        this.typeStatus = id;
        this.active = id;
        // this.getOrderList(this.typeStatus)
      }
    }
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    this.listData = [];
  },
  // 如果是详情页返回则tab 回到之前的tab
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === 'order-detail') {
        vm.active = from.query.type;
      }
    });
  },
  filters: {
    orderStatus(val) {
      switch (val) {
        case 0:
          return '待付款';
        case 1:
          return '已付款';
        case 2:
          return '待发货';
        case 3:
          return '待收货';
        case 4:
          return '已收获';
        case 5:
          return '售后中';
        case 6:
          return '已完成售后';
        case 7:
          return '售后申请驳回';
        default:
          return ' ';
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.order-detail-page {
  // background #efeff4
  width: 100%;
  // overflow hidden
  // padding-bottom 44px
  // height 100%
}

.top-tab {
  margin-bottom: 10px;
}

.order-list {
  // height 500px
  margin-top: 10px;
  overflow: auto;
}

.order-list .list-item {
  margin-bottom: 10px;
  background: #fff;
}

.list-item .order-num {
  height: 43px;
  line-height: 44px;
  padding: 0 15px;
  border-bottom: 1px solid #efeff4;
}

.order-num .normal {
  color: #666;
  font-size: 14px;
}

.order-num .normal .click-copy {
  font-size: 12px;
}
.order-num .normal {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  width: 300px;
}

.order-num .green-color {
  color: #5DC841;
  font-size: 14px;
}

.pic-box {
  height: 79px;
  padding: 10px 15px;
  border-bottom: 1px solid #e5e5e5;
}

.pic-box img {
  width: 80px;
  height: 80px;
  float: left;
  background: #eee;
}

.pic-box .card-msg {
  margin-left: 10px;
  float: left;
  width: 255px;
  position: relative;
  height: 80px;
}

.card-msg .card-name {
  color: #333;
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  line-height: 20px;
  max-height: 40px;
  overflow: hidden;
}

.card-msg .card-num {
  color: #666;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
}

.card-msg .card-date {
  font-size: 12px;
  line-height: 18px;
  height: 18px;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}

.card-msg .card-date .time {
  color: #999;
  float: left;
}

.card-msg .card-date .pic-price {
  font-size: 14px;
  color: #333;
  font-weight: 600;
  float: right;
}

.list-item .download {
  text-align: right;
  padding: 7px 15px 7px 0;
  height: 30px;
}

.download .download-btn {
  width: 94px;
  height: 30px;
  line-height: 30px;
  background: #FF3400;
  border-radius: 4px 4px;
  display: block;
  float: right;
  margin-left: 3px;
}
.plain{
  width: 94px;
  height: 30px;
  line-height: 30px;
  // background: #FF3400;
  border-radius: 4px 4px;
  display: block;
  // float: right;
  background-color: #fff;
  color: #FC4C00;
  border: 2rpx solid #FC4C00;
  // margin-right: 5px;
  }

.red-color {
  color: #ee0a24;
  font-size: 14px;
}

.code-box {
  text-align: center;
  padding: 23px 30px 20px 30px;
}

.code-box img {
  width: 299px;
  height: 300px;
}

.code-box .saveBtn {
  width: 315px;
  height: 44px;
  border-radius: 4px 4px;
  background: #FF3400;
  color: #fff;
}

.code-box .tips {
  color: #999;
  font-size: 12px;
  margin-top: 20px;
}

.nothing {
  text-align: center;
  margin: 43% auto 0;
}

.nothing .bg-box {
  width: 222px;
  height: 222px;
}

.nothing span {
  font-size: 14px;
  color: #333;
}

.to-home {
  position: fixed;
  bottom: 242px;
  width: 100%;
  text-align: center;
}

.to-home-btn {
  width: 335px;
  border-radius: 8px 8px;
}

.to-home-btn span {
  color: #ffffff;
}

.get-way-wrapper .get-way-title {
  margin-bottom: 10px;
  text-align: center;
  color: #333333;
  font-size: 18px;
  padding-top: 50px;
}

.dialog-box {
  z-index: 999 !important;
}

.dialog-box .dialogTitle {
  margin: 50px 0 29px;
  text-align: center;
  color: #333333;
  font-size: 18px;
}

.dialog-box .dialogTest {
  color #E64340 {
    font-size: 12px;
    text-align: center;
  }
}

.email-title {
  margin: 30px 0 10px;
  text-align: center;
  color: #333333FF;
  font-size: 18px;
}

.email-input {
  width: 258px;
  height: 44px;
  background: #F8F8F8FF;
  margin: 0 auto 10px;
}

.wrapper-box, .get-way-wrapper {
  height: 197px;
  width: 335px;
  margin: 55% auto 0;
  background: #fff;
}

.wrapper-box .email-title {
  padding-top: 20px;
  text-align: center;
  color: #333333FF;
  font-size: 18px;
}

.get-way-btn {
  width: 150px;
  height: 47px;
  text-align: center;
  border-radius: 5px;
  margin-top: 14px;
}

.dialog-btn {
  width: 150px;
  height: 47px;
  text-align: center;
  border-radius: 5px;
  margin-top: 14px;
}

.btn1 {
  background: #FF5E27FF;
  color: #ffffff;
}

.btn2 {
  color: #FF5E27FF;
  margin: 0 5px 0 15px;
}
</style>
